import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationUserSessionPost = {
    path: "/user/session",
    method: ERouteHttpVerb.POST
};
export { routeLocationUserSessionPost };
